import { clearChunkReloadFlag } from "@/helpers/chunkError";
import { Button, Icon, tokens, Typography } from "@vintecc/components";
import { faArrowsRotate } from "@vintecc/pro-light-svg-icons";
import { faCloudExclamation } from "@vintecc/pro-solid-svg-icons/faCloudExclamation";
import { useCommonTranslation } from "@/services/culture/common.translations";

export const ChunkErrorBoundary = () => {
  const { t } = useCommonTranslation();
  const handleRefresh = () => {
    // Clear the loop-guard flag so the auto-reload can fire again if a
    // further chunk error is encountered after this intentional refresh.
    clearChunkReloadFlag();
    window.location.reload();
  };

  return (
    <div className="flex flex-col items-center justify-center gap-8 h-full px-4 text-center">
      <Icon icon={faCloudExclamation} size="10x" color={tokens.color.pink[400]} />
      <Typography variant="h2">{t("errors.chunkLoadTitle")}</Typography>
      <Typography variant="p">{t("errors.chunkLoadDescription")}</Typography>
      <Button startIcon={<Icon icon={faArrowsRotate} />} onClick={handleRefresh}>
        {t("common.refresh")}
      </Button>
    </div>
  );
};
